let lastWishlistActionAt = 0;
const WISHLIST_ACTION_WINDOW_MS = 3000;

document.addEventListener('click', (event) => {
  if (event.target.closest('.product-card__wishlist')) {
    lastWishlistActionAt = Date.now();
  }
});

function isRecentWishlistAction() {
  return Date.now() - lastWishlistActionAt < WISHLIST_ACTION_WINDOW_MS;
}

function isWishlistrError(text) {
  return typeof text === 'string' && /wishlist/i.test(text);
}

window.addEventListener('error', (event) => {
  if (!isRecentWishlistAction()) return;
  if (!isWishlistrError(event.filename) && !isWishlistrError(event.message)) return;
  theme.toast?.show({ type: 'error', message: theme.locales.product.wishlistError });
});

window.addEventListener('unhandledrejection', (event) => {
  if (!isRecentWishlistAction()) return;
  const reason = event.reason;
  const text = (reason && (reason.stack || reason.message)) || String(reason || '');
  if (!isWishlistrError(text)) return;
  theme.toast?.show({ type: 'error', message: theme.locales.product.wishlistError });
});

if (!customElements.get('product-card-wishlist-remove')) {
  const WISHLIST_REMOVE_TIMEOUT_MS = 8000;

  class ProductCardWishlistRemove extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.clearLoadingState = this.clearLoadingState.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.clearLoadingState();
    }

    clearLoadingState() {
      this.observer?.disconnect();
      clearTimeout(this.loadingTimeout);
      this.querySelector('.product-card__wishlist-remove')?.classList.remove('is-loading');
    }

    handleClick(event) {
      event.preventDefault();
      const wishlistButton = this.parentElement.querySelector('.product-card__wishlist .wishlist-button');
      if (!wishlistButton) return;

      this.clearLoadingState();
      const button = this.querySelector('.product-card__wishlist-remove');
      button?.classList.add('is-loading');
      wishlistButton.click();

      this.loadingTimeout = setTimeout(this.clearLoadingState, WISHLIST_REMOVE_TIMEOUT_MS);

      this.observer = new MutationObserver(() => {
        if (wishlistButton.classList.contains('active')) return;
        this.clearLoadingState();
      });
      this.observer.observe(wishlistButton, { attributes: true, attributeFilter: ['class'] });
    }
  }

  customElements.define('product-card-wishlist-remove', ProductCardWishlistRemove);
}
